import {ApiInterface} from '@/plugins/core/api/interface';

const apis: ApiInterface[] = [
  {
    name: 'config',
    actions: [
      {
        name: 'retrieve',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/component/retrieve_config',
      },
      {
        name: 'retrieve_gateway_additional_info',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/retrieve_gateway_additional_info',
      },
    ],
  },
  {
    name: 'payment_intent',
    actions: [
      {
        name: 'confirm',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
        endpoint: '/api/internal/payment_intents/confirm',
        recaptcha: true,
      },
      {
        name: 'cancel',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        endpoint: '/api/internal/payment_intents/cancel',
      },
      {
        name: 'retrieve',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
        },
        endpoint: '/api/internal/payment_intents/retrieve',
        recaptcha: true,
      },
      {
        name: 'fetch_gateway_credential',
        method: 'get',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/fetch_gateway_public_credential',
      },
      {
        name: 'generate_braintree_client_token',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/generate_braintree_client_token',
      },
      {
        name: 'generate_adyen_origin_key',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/generate_adyen_origin_key',
      },
      {
        name: 'create_bluesnap_pf_token',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/create_bluesnap_pf_token',
      },
      {
        name: 'generate_device_data_jwt',
        method: 'post',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        endpoint: '/api/internal/payment_intents/generate_device_data_jwt',
      },
      {
        name: 'fetch_gateway_token',
        method: 'get',
        endpoint: (params) => `/api/js/v2/tokens/${params.cbToken}/`,
        jsApi: true,
        recaptcha: true,
        skipBusinessEntityId: true,
      },
      {
        name: 'retrieve_braintree_payment_method_nonce',
        method: 'get',
        endpoint: (params) => `/api/internal/payment_intents/braintree/nonce?nonce=${params.nonce}`,
        jsApi: true,
        recaptcha: true,
        skipBusinessEntityId: true,
      },
    ],
  },
];

export default apis;
